import { formatProcessInstanceId } from '../../../../utils/formatting_utils';
import { getParamUrl } from '../../../../utils/query_string_parser';

export default class ShowMessageResponseHandler {
	static execute(response) {
		const nextActivities = response.activities;
		if(!!nextActivities && nextActivities.length > 0) {
			return this.parseMessagesByActivities(response);
		} else {
			return this.parseFinalActivityMessages(response);
		}
	}

	static parseMessagesByActivities(response) {
		const nextActivities = response.activities;
		return nextActivities.map(ShowMessageResponseHandler.parseActivityMessages.bind(this, response));
	}

	static parseActivityMessages(response, nextActivity) {
		const messages = [];

		ShowMessageResponseHandler.addCustomMessage(response, messages);

		if (getParamUrl("newWS") === "true") {
			messages.push(ShowMessageResponseHandler.parseNextActivityMessage(nextActivity));
		}

		if (nextActivity.isSubProcess)
			messages.push(ShowMessageResponseHandler.parseSubProcessMessage(nextActivity));
		else
			messages.push(ShowMessageResponseHandler.parseNextResponsiblesMessage(nextActivity));

		ShowMessageResponseHandler.addIntegrationMessage(response, messages);

		return {
			activityInstanceData: nextActivity,
			messages: messages
		};
	}

	static parseSubProcessMessage(nextActivity) {
		let message = "";

		message += `${Realize.i18n.t('activity.messages.subProcess')} `;
		message += formatProcessInstanceId(nextActivity.createdSubProcessInstance);

		return ShowMessageResponseHandler.buildMessageObject(message);
	}

	static parseFinalActivityMessages(response) {
		const messages = [];
		ShowMessageResponseHandler.addCustomMessage(response, messages);
		messages.push(ShowMessageResponseHandler.buildMessageObject(Realize.i18n.t('activity.messages.activityFinished')));
		messages.push(ShowMessageResponseHandler.parseProcessFinishedMessage(response));

		return [
			{
				activityInstanceData: null,
				messages: messages
			}
		];
	}

	static addCustomMessage(response, messages) {
		const customMessage = response.customMessage;
		if(!!customMessage && customMessage.length > 0) {
			messages.push(ShowMessageResponseHandler.buildMessageObject(customMessage));
		}
	}

	static addIntegrationMessage(response, messages) {
		const integration = response.integration;
		if(!!integration && !!integration.integrationName) {
			messages.push(ShowMessageResponseHandler.parseIntegrationMessage(integration));
		}
	}

	static parseNextActivityMessage(nextActivity) {
		const message = `${Realize.i18n.t('activity.messages.nextActivity')}: ${nextActivity.activityName}`;
		return ShowMessageResponseHandler.buildMessageObject(message);
	}

	static parseNextResponsiblesMessage(nextActivity) {
		let message = "";
		const users = nextActivity.users;

		message += `${Realize.i18n.t('activity.messages.nextResponsibles')}: `;
		message += users.map((user) => user.name).join(', ');

		return ShowMessageResponseHandler.buildMessageObject(message);
	}

	static parseProcessFinishedMessage(response) {
		let message = "";
		message += `${Realize.i18n.t('process.messages.processFinished')}. Status: `;
		message += Realize.i18n.t(`process.status.${response.status}`);

		return ShowMessageResponseHandler.buildMessageObject(message);
	}

	static parseIntegrationMessage(integration) {
		const integrationTranslation = Realize.i18n.t('activity.messages.integration');
		const executedTranslation = Realize.i18n.t('activity.messages.executed');
		const message = `${integrationTranslation} ${integration.integrationName} ${executedTranslation}: ${integration.integrationResult}`;

		return ShowMessageResponseHandler.buildMessageObject(message, true);
	}

	static buildMessageObject(message, htmlSafe=false) {
		return { message, htmlSafe };
	}
}
